import { render, staticRenderFns } from "./TokenCopyIcon.vue?vue&type=template&id=29788623"
import script from "./TokenCopyIcon.vue?vue&type=script&lang=js"
export * from "./TokenCopyIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports